import { api } from "../api/requests";

// Mark Commission as paid and settle
export async function markCommissionAsPaidAndSettle(commissionId: string): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.get(`admin/commissions/${commissionId}/mark-paid-and-settle`)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}

// Mark Commission as paid and settle
export async function markBulkCommissionAsPaidAndSettle(commissionIds: string[]): Promise<void> {
    return new Promise<any>((resolve, reject) => {
        api.post(`admin/commissions/mark-paid-and-settle`, commissionIds)
            .then((response: any) => {
                resolve(response?.data);
            })
            .catch((error: any) => {
                reject(error)
            })
    })
}
